import { Circle } from "lucide-react";
import { Candidate } from "@/types/candidate";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { MatchScore } from "@/components/MatchScore";
import { getInitials, getStatusColor } from "./utils/ProfileUtils";
import { useTranslation } from "react-i18next";

interface CandidateHeaderProps {
  candidate: Candidate;
}

export const CandidateHeader = ({ candidate }: CandidateHeaderProps) => {
  const statusColor = getStatusColor(candidate.status);
  const { t } = useTranslation();
  
  return (
    <div className="flex items-start gap-4 mb-4">
      <Avatar className="h-16 w-16">
        <AvatarFallback className="text-lg bg-digger-blue text-white">
          {getInitials(candidate.name)}
        </AvatarFallback>
      </Avatar>
      <div className="grid gap-1">
        <h2 className="text-2xl font-bold">{candidate.name}</h2>
        
        <div className="flex items-center gap-2">
          {candidate.status && (
            <div className="flex items-center gap-1.5">
              <Circle className={`h-3 w-3 fill-current ${statusColor}`} />
              <span className="text-sm text-gray-600">{candidate.status}</span>
            </div>
          )}
          {candidate.function && (
            <>
              <span className="text-gray-400">•</span>
              <span className="text-sm text-gray-600">{candidate.function}</span>
            </>
          )}
        </div>
        
        {candidate.match_score !== undefined && (
          <div className="flex items-center gap-2 mt-1">
            <span className="text-sm text-gray-500">{t("candidates.profile.matchScore")}</span>
            <MatchScore score={candidate.match_score} />
          </div>
        )}
      </div>
    </div>
  );
};
